module.exports = __webpack_public_path__ + "img/train-tool.f1459a74.jpeg";